import { createStyles } from 'antd-style'

import { contrastRatio } from 'src/theme/contrast'
import { darkPalette, lightPalette } from 'src/theme/palette'

type Props = {
  bgColor: string
  initialsFontSize: number
}

// Same rule as ebs-platform-web's UserAvatar: the initials take whichever
// on-fill neutral (white or the near-black) reads better on the generated
// colour, so a light hue never carries white text.
const initialsColorOn = (bgColor: string) =>
  bgColor === 'transparent' ||
  contrastRatio(lightPalette.textOnPrimary, bgColor) >=
    contrastRatio(darkPalette.textOnPrimary, bgColor)
    ? lightPalette.textOnPrimary
    : darkPalette.textOnPrimary

export const useStyles = createStyles(
  (_, { bgColor, initialsFontSize }: Props) => {
    return {
      avatar: {
        img: {
          objectFit: 'contain'
        },

        backgroundColor: bgColor,
        color: initialsColorOn(bgColor),

        '.ant-avatar-string': {
          fontSize: initialsFontSize,
          fontWeight: 500
        }
      }
    }
  }
)
